import { apiClient } from "./base.service";
import { auth } from "../firebase/config";
import type {
  ApiKeySummary,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
} from "@/types/api-key.types";

class ApiKeyService {
  private async getAuthHeaders(): Promise<Record<string, string>> {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }

    const token = await user.getIdToken();
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async list(): Promise<ApiKeySummary[]> {
    const headers = await this.getAuthHeaders();
    return apiClient.get<ApiKeySummary[]>("/auth/api-keys", { headers });
  }

  async create(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
    const headers = await this.getAuthHeaders();
    return apiClient.post<CreateApiKeyResponse>("/auth/api-keys", data, {
      headers,
    });
  }

  async revoke(keyId: string): Promise<ApiKeySummary> {
    const headers = await this.getAuthHeaders();
    return apiClient.delete<ApiKeySummary>(`/auth/api-keys/${keyId}`, {
      headers,
    });
  }
}

export const apiKeyService = new ApiKeyService();
